/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Review_Fast_Track_DescInputs */

const en_directory_submit_review_fast_track_desc = /** @type {(inputs: Directory_Submit_Review_Fast_Track_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live today with a dofollow link — no badge needed, no subscription.`)
};

const zh_directory_submit_review_fast_track_desc = /** @type {(inputs: Directory_Submit_Review_Fast_Track_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今天上线，带 dofollow 外链——不用挂徽章，也不用订阅。`)
};

/**
* | output |
* | --- |
* | "Live today with a dofollow link — no badge needed, no subscription." |
*
* @param {Directory_Submit_Review_Fast_Track_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_review_fast_track_desc = /** @type {((inputs?: Directory_Submit_Review_Fast_Track_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Review_Fast_Track_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_review_fast_track_desc(inputs)
	return zh_directory_submit_review_fast_track_desc(inputs)
});
export { directory_submit_review_fast_track_desc as "directory.submit.review.fast_track_desc" }